import { useEffect } from "react";
import useIsDesktop from "../hooks/useIsDesktop";
import { Headers } from "../components/ui/heading";
import { LipaBidhaaContent } from "../components/LipaBidhaa/LipaBidhaaContent";
import CustomNotificationBanner from "../components/ui/CustomNotificationBanner/CustomNotificationBanner";
import { useLipaBidhaaBanner } from "../components/LipaBidhaa/shared/useLipaBidhaaBanner";
import { useOtpBlockCountdown } from "../hooks/useOtpBlockCountdown";
import { OtpBlockBanner } from "../components/shared/OtpBlockBanner";
import useLipaBidhaaStore from "../stores/lipaBidhaaStore";
import {
  useLipaBidhaaOtpBlockStore,
  usePinLockedStore,
} from "../stores/useOtpBlockStore";

function LipaBidhaa() {
  const isDesktop = useIsDesktop();
  const { banner, dismissBanner } = useLipaBidhaaBanner();
  const { isBlocked: isOtpBlocked, countdown: otpCountdown } =
    useOtpBlockCountdown(useLipaBidhaaOtpBlockStore);
  const { isBlocked: isPinLockedBlock, countdown: pinCountdown } =
    useOtpBlockCountdown(usePinLockedStore);
  const isBlocked = isOtpBlocked || isPinLockedBlock;
  const countdown = isPinLockedBlock ? pinCountdown : otpCountdown;

  useEffect(() => {
    useLipaBidhaaStore.getState().reset();
  }, []);

  return (
    <div className="p-6 sm:min-h-full sm:flex sm:items-center sm:justify-center pb-16">
      <div className="max-w-[1480px] w-full">
        {isBlocked && isPinLockedBlock && (
          <OtpBlockBanner
            countdown={countdown}
            title="PIN Locked"
            message={`Your payment PIN has been locked for security reasons. Try again in ${countdown}, or contact customer support to continue.`}
          />
        )}

        {isBlocked && !isPinLockedBlock && (
          <OtpBlockBanner countdown={countdown} />
        )}

        {!isBlocked && banner && (
          <div className="mb-6 flex justify-center">
            <CustomNotificationBanner
              variant={banner.variant}
              title={banner.title}
              message={banner.message}
              onClose={dismissBanner}
              maw={440}
            />
          </div>
        )}

        {isDesktop ? (
          <div className="text-center mb-10">
            <h1 className="text-2xl font-semibold text-gray-900">
              Lipa Bidhaa
            </h1>
            <p className="text-sm text-gray-600 mt-1">
              Send direct payments to suppliers and utility providers
            </p>
          </div>
        ) : (
          <Headers
            name="Lipa Bidhaa"
            subtitle="Send direct payments to suppliers and utility providers"
          />
        )}

        <LipaBidhaaContent isBlocked={isBlocked} />
      </div>
    </div>
  );
}

export default LipaBidhaa;
